<template>
  <v-navigation-drawer dark class="hero-img" permanent style="height: 100vh;" app fixed>
    <v-card v-if="bookie !== 'pronet'" class="pa-2 pl-4 mb-5" height="30px" style="background:transparent; position:relative" elevation="0">
      <v-img :src="`${logoPath}`" alt="logo" max-width="120" max-height="48" contain class="logo"></v-img>
    </v-card>
    <!--If runner data exists-->
    <div class="meetings-scroll" v-if="runnerData">
      <v-list>
        <v-list-item v-for="d in filterScratched(runnerData.competitors)" :key="d.tabNo" style="padding-left: 5px; padding-right: 5px;" class="meetings-list mb-n2">
          <a :href="`#`+d.tabNo" class="jockeyLink" style="color: white; width: 100%; height: 100%;">

            <v-list-item-icon style="margin-right: 5px !important; margin-top: 0px !important; margin-bottom: 0px !important; float: left">
              <img v-if="runnerData.meeting.type === 'THOROUGHBRED' || runnerData.meeting.type === 'HARNESS'" :src="$silksUrl+'/'+gbsID+'_'+runnerData.number+'_'+d.tabNo+'_64x64.png'" alt="jockey silks" height = "32">
              <div v-if="runnerData.meeting.type === 'GREYHOUND' && runnerData.meeting.track.country === 'GBR' && d.tabNo" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUk-' + d.tabNo]" />
              <div v-if="runnerData.meeting.type === 'GREYHOUND' && runnerData.meeting.track.country === 'AUS' || runnerData.meeting.type === 'GREYHOUND' && runnerData.meeting.track.country === 'NZL' && d.tabNo" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteAUS-' + d.tabNo]" />
              <div v-if="runnerData.meeting.type === 'GREYHOUND' && runnerData.meeting.track.country === 'USA' || runnerData.meeting.track.country === 'MEX' && d.tabNo" style="width:28px;margin-top:2px;overflow:hidden;" :class="['greyhoundSpriteUs-' + d.tabNo]" />
            </v-list-item-icon>
            <v-list-item-content v-if="!d.scratched" style="padding: 0" class="pt-2 text-left">
              <div>
                <div style="float:left;max-width: 130px; text-overflow: ellipsis; white-space: nowrap; overflow:hidden; padding-right: 5px;" class="subtitle-2">{{d.tabNo}}. {{d.name}}</div>
                <div style="float:left;max-width: fit-content; padding-bottom: 2px;" class="subtitle-2">({{d.barrier}})</div>
                <div label small class="float-right text-right body-2 pl-1 pr-1" style="width:45px;color:#dadada; text-align:center" >{{getRunnerFixedOdd(d.tabNo)}}</div>
              </div>
            </v-list-item-content>
          </a>
        </v-list-item>
      </v-list>
    </div>
    <!--Show skeleton loader if no data exists-->
    <div v-else>
      <v-list v-for="idx in 20" :key="idx" class="meetings-list">
        <v-skeleton-loader
          type="list-item-avatar"
        ></v-skeleton-loader>
      </v-list>
    </div>
    <div style="position: absolute; bottom: 0; color: white" class="ml-3">
      Build Number - FRONTENDVERSION
    </div>
  </v-navigation-drawer>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'RunnerNavBar',
  data () {
    return {
      logoPath: process.env.BASE_URL + 'logos/' + window.location.host.split('.')[0] + '.png'
    }
  },
  computed: {
    ...mapState(['gbsID', 'bestOddsArray', 'bookie'])
  },
  methods: {
    getRunnerFixedOdd (tabNo) {
      let fixedPrice = 0
      if (this.bestOddsArray.length >= 1) {
        this.bestOddsArray.forEach(b => {
          // eslint-disable-next-line eqeqeq
          if (tabNo == b.tabNo) {
            fixedPrice = b.price
          }
        })
      } else {
        this.runnerData.competitors.forEach(b => {
          // eslint-disable-next-line eqeqeq
          if (tabNo == b.tabNo) {
            // eslint-disable-next-line eqeqeq
            const newPrices = b.prices.filter(b => b.type == 'WIN_FIXED_ODDS')
            const flucs = newPrices.map(a => a.price)
            fixedPrice = flucs[flucs.length - 1] || 0
          }
        })
      }
      return `$${this.toFixedIfNecessary(fixedPrice, 2)}`
    },
    toFixedIfNecessary (value, dp) {
      return +parseFloat(value).toFixed(dp)
    },
    filterScratched (runners) {
      const mapRunners = runners.filter(b => !b.scratched)
      return mapRunners.slice().sort((a, b) => a.tabNo - b.tabNo)
    }
  },
  props: {
    runnerData: Object
  }
}
</script>

<style>
.jockeyLink {
  border:none;
  outline:none;
  text-decoration:none;
  color:inherit;
}
.hero-img {
  background-size: cover;
  background-image: url('../assets/tbmsidebar.png');
}
.v-list-item:hover {
  background-color: rgba(255, 255, 255, 0.3);
}
/* UK Greys */
.greyhoundSpriteUk-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteUk-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteUk-3 {
  width: 28px;
  height: 28px;
  border: 1px solid #333;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteUk-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteUk-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteUk-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteUk-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteUk-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_UKGreysSprite_lrg.png') 0 -196px;
}
/* AUS Greys */
.greyhoundSpriteAUS-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteAUS-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteAUS-3 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteAUS-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteAUS-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteAUS-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteAUS-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteAUS-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -196px;
}
.greyhoundSpriteAUS-9 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -224px;
}
.greyhoundSpriteAUS-10 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_AUSGreysSprite_lrg.png') 0 -252px;
}
/* US Greys */
.greyhoundSpriteUs-1 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 0px;
}
.greyhoundSpriteUs-2 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -28px;
}
.greyhoundSpriteUs-3 {
  width: 28px;
  height: 28px;
  border: 1px solid #333;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -56px;
}
.greyhoundSpriteUs-4 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -84px;
}
.greyhoundSpriteUs-5 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -112px;
}
.greyhoundSpriteUs-6 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -140px;
}
.greyhoundSpriteUs-7 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -168px;
}
.greyhoundSpriteUs-8 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -196px;
}
.greyhoundSpriteUs-9 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -224px;
}
.greyhoundSpriteUs-10 {
  width: 28px;
  height: 28px;
  background: url('~@/assets/greyhounds/DO_USGreysSprite_lrg.png') 0 -252px;
}
</style>
